var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._g(_vm._b({class:[
    'vts-form',
    {
      'vts-form--invalid': !_vm.valid,
      'vts-form--dirty': _vm.dirty,
      'vts-form--error': _vm.error,
    } ],attrs:{"method":_vm.$attrs.method || 'POST'},on:_vm._d({},[_vm.event,_vm.onEvent])},'form',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",null,null,{ valid: _vm.valid, dirty: _vm.dirty, error: _vm.error, inputs: _vm.inputs, clear: _vm.clear })],2)}
var staticRenderFns = []

export { render, staticRenderFns }